import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';
import Nomenclatures from "@/module/store/nomenclatures"
import {iNomCategOfEvents} from '@/types/iNomCategOfEvents';
import {iNomTypesOfEvents} from '@/types/iNomTypesOfEvents';
import { date } from 'quasar';
import {Cropper } from 'vue-advanced-cropper';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {I_List} from "@/types/iList";


interface I_AjaxResponse_GetListDetails{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        list_header:I_List
    }
}

@Component({components:{Cropper}})
export default class EditImageForList extends Vue {
    @Prop() listid!: number;
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    getUrlForUploadImageList:string;
    imgIsUploadingForCropper:boolean=false;
    ajaxIsRunning:boolean=false;
    image: any;
    coordinates:any;
    listHeader:I_List={
        userid:0,
        listid:0,
        list_name:'',
        name_of_titular_event:'',
        type_of_event:0,
        contact_phone:'',
        event_time:'',
        event_time_data:'',
        event_time_ora:'',
        privacy_type:'',
        password_list:'',
        description:'',
        location_county:'',
        location_city:'',
        location_street:'',
        location_text:'',
        type_of_titular_event:'',
        status:'',
        has_attached_image:'',
        url_for_img:'',
        token_pt_acces_lista:''
    }


    $refs:any;
    private userStore=getModule(User)
    private nomenclaturesStore=getModule(Nomenclatures);

    constructor(){
        super();
        this.image=null;
        this.getUrlForUploadImageList=CONFIG_ENV.URL_LISTS.uploadImageForList+'/'+this.listid;
        this.coordinates={
                width: 0,
                height: 0,
                left: 0,
                top: 0
            }
    }

    async getListDetailsFromDB(plistid:number){
        const vueInst=this;
        let resFromAjax = await <Promise<I_AjaxResponse_GetListDetails>> axios.get(`${CONFIG_ENV.URL_GIFTS.get_list_details}/${plistid}`);
        vueInst.listHeader.listid=resFromAjax.data.list_header.listid;
        vueInst.listHeader.list_name=resFromAjax.data.list_header.list_name;
        vueInst.listHeader.name_of_titular_event=resFromAjax.data.list_header.name_of_titular_event;
        vueInst.listHeader.type_of_event=resFromAjax.data.list_header.type_of_event;
        vueInst.listHeader.contact_phone=resFromAjax.data.list_header.contact_phone;
        vueInst.listHeader.privacy_type=resFromAjax.data.list_header.privacy_type;
        vueInst.listHeader.password_list=resFromAjax.data.list_header.password_list;
        vueInst.listHeader.description=resFromAjax.data.list_header.description;
        vueInst.listHeader.location_county=resFromAjax.data.list_header.location_county;
        vueInst.listHeader.location_city=resFromAjax.data.list_header.location_city;

        vueInst.listHeader.location_street=resFromAjax.data.list_header.location_street;
        vueInst.listHeader.location_text=resFromAjax.data.list_header.location_text;
        vueInst.listHeader.type_of_titular_event=resFromAjax.data.list_header.type_of_titular_event;
        vueInst.listHeader.status=resFromAjax.data.list_header.status;

        let eventDate = date.buildDate({ year:resFromAjax.data.list_header.event_time.substr(0, 4),
            month:resFromAjax.data.list_header.event_time.substr(5, 2),
            date:resFromAjax.data.list_header.event_time.substr(8, 2),
            hours:resFromAjax.data.list_header.event_time.substr(11, 2),
            minutes:resFromAjax.data.list_header.event_time.substr(14, 2)
        })
        vueInst.listHeader.event_time_data= date.formatDate(eventDate, 'DDMMM,YYYY');
        vueInst.listHeader.event_time_ora= date.formatDate(eventDate, 'HH:mm');
    }

    emitReloadProfileImage(){

    }

    readyImage(){
        this.imgIsUploadingForCropper=false;
        this.$q.loading.hide();
    }

    uploadImage(event:any) {
        // Reference to the DOM input element
        this.imgIsUploadingForCropper=true;
        this.$q.loading.show();
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                // @ts-ignore
                this.image = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    }

    ataseazaImagineaLaLista(){
        const vueInst=this;
        console.log('ataseazaImagineaLaLista start upload');
        vueInst.imgIsUploadingForCropper=true;
        this.$q.loading.show();
        //console.log('ataseazaImagineaLaLista image=%o',this.image)
        const {coordinates, canvas} = this.$refs.cropper.getResult();
        this.coordinates = coordinates
        // You able to do different manipulations at a canvas
        // but there we just get a cropped image
        var vimage = canvas.toDataURL();
        const type = vimage.split(';')[0].split('/')[1]
        axios.post(vueInst.getUrlForUploadImageList, vimage, {
            headers: {
                'Content-Type': type
            }
            /*,
            onUploadProgress: function (progressEvent) {
                vueInst.imgIsUploadingForCropper=true;
                vueInst.$q.loading.show();
            }
            */
        }).then(presult=>{
            console.log('ataseazaImagineaLaLista upload was finished');
            vueInst.$q.loading.hide();
            if(presult.data.status=='success'){
             vueInst.eventAnImageForListWasUploaded();
            }else{
                vueInst.$q.notify({
                    color: 'red',
                    textColor: 'white',
                    position:'bottom-right',
                    icon: 'fas fa-exclamation-triangle',
                    message: presult.data.message
                });
            }
        });
    }

    // @ts-ignore
    onChange({coordinates, canvas}) {
        // You able to do different manipulations at a canvas
        // but there we just get a cropped image
        this.image = canvas.toDataURL()
    }

    eventAnImageForListWasUploaded(){
        this.$emit('infofromchildCommand', 'AnImageForListWasUploaded');
        this.$q.notify({
            color: 'teal',
            textColor: 'white',
            position:'bottom-right',
            icon: 'fas fa-exclamation-triangle',
            message: 'Imaginea a fost schimbata!'
        });
    }
    activated(){
        const vueInst=this;
        if(vueInst.listid && 1*vueInst.listid>0){
            vueInst.getListDetailsFromDB(vueInst.listid);
        }
        else{
            vueInst.$q.notify({
                color: 'red-5',
                textColor: 'white',
                position:'top-right',
                icon: 'fas fa-exclamation-triangle',
                message: 'Lipseste identificatorul listei! Apasati F5 si incercati din nou!'
            });
        }
    }
}
